const Accordion = function(args) {
    
    const options = Object.assign({
        element: '.accordion',
        titleClass: 'accordion__title',
        contentClass: 'accordion__content',
        hideBody: false,
        onlyOneOpen: true,
        breakpoints: {
            768: {
                hideBody: true
            }
        },
        onTabOpen: null
    }, args);
    let timeouts = [];
    let animationTimeouts = [];
    const element = document.querySelector(options.element);
    
    render();

    window.addEventListener('resize', function() {
        [].forEach.call(element.querySelectorAll('.'+options.titleClass), function(item) {
            item.nextElementSibling.style.removeProperty('maxHeight');
            item.nextElementSibling.style.removeProperty('transition');
            item.nextElementSibling.style.removeProperty('display');
            item.nextElementSibling.style.removeProperty('overflow');
        });
    })
    function displayContent() {
        let allowToMove = !options.hideBody;
        if (options.breakpoints) {
            Object.keys(options.breakpoints).forEach( (key) => {
                if (window.innerWidth >= key && typeof options.breakpoints[key].hideBody !== 'undefined') {
                    if (options.breakpoints[key].hideBody === true) {
                        allowToMove =  false;
                    } 
                }
            });
        }
        return allowToMove;
    }
    
    function render() {
        if (element) {
            [].forEach.call(element.querySelectorAll('.'+options.titleClass), function(item) {
                item.addEventListener('click', onClick);
                item.nextElementSibling.style.boxSizing = 'border-box';
            });
        }
    }
    function destroy() {
        [].forEach.call(element.querySelectorAll('.'+options.titleClass), function(item) {
            item.removeEventListener('click', onClick);
            item.nextElementSibling.style.removeProperty('maxHeight');
            item.nextElementSibling.style.removeProperty('transition');
            item.nextElementSibling.style.removeProperty('display');
            item.nextElementSibling.style.removeProperty('overflow');
        });
    }
    function onClick(e) {
        if (e.target.className.indexOf(options.titleClass) === -1) {
            return;
        }
        const opened = element.querySelectorAll(`.${options.titleClass}--opened`);
        if (opened.length > 0 && options.onlyOneOpen) {
            opened.forEach( item => {
                if (item !== e.target) {
                    hide(item);
                }
            })
        }
        toggle(e.target);
        if (e.sourceCapabilities !== null) {
            e.target.blur();
        }
        if (typeof options.onTabOpen === 'function') {
            options.onTabOpen(e.target);
        }
    }

    function toggle(el) {
        const container = el.nextElementSibling;
        if (container.classList.contains('open')) {
            if (displayContent()) {
                hide(el);
            }
        } else {
            show(el);
        }
    }
    function show(el) {
        const tabIndex = el.parentNode.getAttribute('data-tab');
        const container = el.nextElementSibling;
        container.style.display = 'block';
        container.style.removeProperty('max-height');
        container.style.removeProperty('transition');
        container.style.overflow = 'visible';
        const height = container.scrollHeight;
        container.style.maxHeight = 0;
        container.style.overflow = 'hidden';
        container.style.transition = 'max-height 0.3s ease-out';
        

        el.classList.add(`${options.titleClass}--opened`);
        if (animationTimeouts[tabIndex]){
            clearTimeout(animationTimeouts[tabIndex]);
            animationTimeouts[tabIndex] = null;
        }            
        if (timeouts[tabIndex]) {
            clearTimeout(timeouts[tabIndex]);
            timeouts[tabIndex] = null;
        }
        if (displayContent()) {            
            container.classList.add('open');
            timeouts[tabIndex] = setTimeout(function() {
                container.style.maxHeight = height + 'px';
                animationTimeouts[tabIndex] = setTimeout(function() {
                    container.style.removeProperty('max-height');
                    container.style.display = 'block';
                }, 310);
            },10);
        } else {
            container.style.removeProperty('max-height');
        }
        container.classList.add('open');
    }
    function hide(el) {
        const tabIndex = el.parentNode.getAttribute('data-tab');
        const container = el.nextElementSibling;
        if (timeouts[tabIndex]) {
            clearTimeout(timeouts[tabIndex]);
            timeouts[tabIndex] = null;
        }
        if (animationTimeouts[tabIndex]){
            clearTimeout(animationTimeouts[tabIndex]);
            animationTimeouts[tabIndex] = null;
        }
        if (displayContent()) {
            container.style.removeProperty('transition');
            container.style.removeProperty('max-height');
            container.style.overflow = 'hidden';
            container.style.maxHeight = container.scrollHeight + 'px';
            container.style.transition = 'max-height 0.3s ease-out';
        }
        el.classList.remove(`${options.titleClass}--opened`);
        container.classList.remove('open');        
        timeouts[tabIndex] = setTimeout(function() {
            container.style.maxHeight = 0;
            animationTimeouts[tabIndex] = setTimeout(function() {
                container.style.removeProperty('block');
                container.style.removeProperty('transition');             
            },310);
        }, 10);
        
    }
    return {
        render: render,
        destroy: destroy
    };
}
export default Accordion;